<div class="search-container" [class.align-right]="alignRight" [class.full-width]="fullWidth">
    <div class="search-bar" [class.full-width]="fullWidth">
        <input (focus)="searchHasFocus()" matInput [(ngModel)]="searchQuery" [placeholder]="'Filter ' + placeholder" (keyup)="searchChange($event)">
        <div class="cancel">
            <button *ngIf="isSearching" (click)="cancelSearch()" mat-button><mat-icon>cancel</mat-icon></button>
        </div>
    </div>
</div>

<!-- <div *ngIf="isSearching" class="cancel-search-button">
    <button (click)="cancelSearch()" mat-raised-button>Cancel Search</button>
</div> -->
